'use client';

import { AnchorTab, anchorTabTag } from '@ni/nimble-components/dist/esm/anchor-tab';
import { wrap } from '../utilities/react-wrapper';

export { anchorTabTag };
export { type AnchorTab };
export const NimbleAnchorTab = wrap(AnchorTab);
